// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__22jxL","filesListContainer":"PosDisputesFiles_filesListContainer__1v0Zb","filesButton":"PosDisputesFiles_filesButton__3YI3V"};